import React from "react";


const TwitterLink = ({
  url,
  height = "50px",
  width = "50px",
 // ✅ new prop
}) => {
  return (

      <a href={url}>
        <div style={{  display: 'inline-block',
          width: width,
          height: height,
          position: 'relative',
          overflow: 'hidden',
          verticalAlign: 'middle'}}>
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="256" cy="256" r="256" fill="#000" />

          <g transform="translate(256,256) scale(0.65) translate(-256,-256)">
            <path
              fill="#fff"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M192.034 98H83l129.275 170.757L91.27 412h55.908l91.521-108.34 81.267 107.343H429L295.968 235.284l.236.303L410.746 99.994h-55.908l-85.062 100.694zm-48.849 29.905h33.944l191.686 253.193h-33.944z"
            />
          </g>
        </svg>
        </div>
      </a>

  );
};


export default TwitterLink;